import { Box } from "@mui/material";
import { Carousel as ReactCarousal } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import { configs } from "@/configs";

type CarouselProps = {
  imageUrls: string[];
};

export function Carousel({ imageUrls }: CarouselProps) {
  return (
    <ReactCarousal
      autoPlay={imageUrls.length > 1}
      infiniteLoop
      showArrows={false}
      showStatus={false}
      showThumbs={false}
    >
      {imageUrls.map((imageUrl, index) => (
        <Box
          key={index}
          width="100%"
          pt="66.66%"
          sx={{
            backgroundImage: `url(${imageUrl ?? configs.defaultImageURL})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      ))}
    </ReactCarousal>
  );
}
